import { alphaClient } from '@/services/api-client'
import { VehicleComposition } from '@/types/VehicleComposition'

export const getVehicleComposition = (): Promise<VehicleComposition[]> =>
  alphaClient
    .get<VehicleComposition[]>(
      '/v2/masterdata/vehicleComposition?filter=active'
    )
    .then((x) => x.data)
